import training from './training';
import models from './models';
import jobs from './jobs';
import analysis from './analysis';
import fpReduction from './fpReduction';

export default {
  namespaced: true,
  modules: {
    training,
    models,
    jobs,
    analysis,
    fpReduction,
  },
};
